import * as React from 'react';
import { Popover } from "antd";
import { ReactComponent as SwapIcon } from "../assets/repeat.svg"
import { FormattedMessage } from "react-intl";

interface State {
    visible: boolean
}

interface Props {
    handleIconClick: () => void
}

export class SwapIconPopover extends React.Component<Props> {
    state: State = {
        visible: false
    }

    constructor(props: Props) {
        super(props)
        this.handlePopoverVisibilityChange = this.handlePopoverVisibilityChange.bind(this)
        this.handleClick = this.handleClick.bind(this)
    }

    handlePopoverVisibilityChange = () => {
        this.setState((prevState: State) => ({
            visible: !prevState.visible
        }))
    }

    handleClick() {
        this.setState({
            visible: false
        })
        this.props.handleIconClick()
    }

    render() {
        const popOverContent = <div className="swap-icon-content-div">
            <div className="swap-content-heading"><FormattedMessage id='swap_content_heading'/></div>
            <div className="swap-content-body"><FormattedMessage id='swap_content_desc'/></div>
        </div>
        return <div>
            <Popover
                placement="rightTop"
                content={popOverContent}
                trigger="hover"
                visible={this.state.visible}
                onVisibleChange={this.handlePopoverVisibilityChange}>
                <SwapIcon onClick={() => this.handleClick()} className='swap-icon' />
            </Popover>
        </div>
    }
}